export default __webpack_public_path__ + "static/media/download.ffdea783.svg";